import { graphql, useStaticQuery } from "gatsby"

const useCampaignsDataWeb = () => {
  const data = useStaticQuery(graphql`
    {
      allMarkdownRemark(
        sort: { fields: [frontmatter___sideBarOrder], order: ASC }
        filter: {
          frontmatter: { category: { eq: "Campaigns" }, product: { eq: "web" } }
        }
      ) {
        edges {
          node {
            fields {
              slug
            }
            frontmatter {
              title
              sideBarOrder
              headerLinks
              date
              category
              product
            }
          }
        }
      }
    }
  `)

  return data
}

export default useCampaignsDataWeb
